import type { Platform } from '@/domains/core/settings/interfaces/Platform';

export const PAGE_TYPE_PRODUCT = 'product';

export const PAINT_REDIRECT_FEATURE_FLAG = 252;
export const PREVENT_PAINT_REDIRECTION_FEATURE_FLAG = 533;

export const PRO_SMART_SHOPPING_PP_QUICK_WINS_2 = 624;
export const PP_QUICK_WINS_2 = 260;
export const STOP_PAINTING_REDIRECTION_AB_TEST = 1762;

// MF 100 DAYS FREE RETURNS
export const MF_100_DAYS_FREE_RETURNS_FLAG = '100-days-free-returns';

export const MF_48H_FREE_DELIVERY_B2C_FR = 2639;
export const MF_48H_FREE_DELIVERY_B2B_FR = 2640;

export const B2B_NOT_FOUND_REDIRECTIONS: Record<Platform, string> = {
  fr: '/co/corpro/offre-gros-volumes-2610',
  es: '/co/corpro/ofertas-a-granel-3113',
  it: '/co/corpro/offerta-ingrosso-3114',
  gb: '/bs',
  de: '/bs',
};

export const PRODUCT_NOT_FOUND_QUERY_PARAM = 'fromProduct';

// TODO: PP-1300 remove custom breakpoints and BreakpointProvider
export const PDP_CUSTOM_QUERIES = {
  xs: `screen and (max-width: 419px)`,
  sm: `screen and (min-width: 420px) and (max-width: 767px)`,
  md: `screen and (min-width: 768px) and (max-width: 1023px)`,
  lg: `screen and (min-width: 1024px) and (max-width: 1439px)`,
  xl: `screen and (min-width: 1440px)`,
  mobile: 'screen and (max-width: 420px)',
  phablet: 'screen and (max-width: 600px)',
  tablet: 'screen and (min-width: 421px) and (max-width: 767px)',
};

export enum StringAbTests {
  PLAYLIST_WITH_ARROWS_AT_SIDES = 'smart-shopping-playlist-side-arrows',
  RECOMMENDED_BY_PROS_LABEL = 'smart-shopping-recommended-by-pros',
  USE_GRAPHQL_FOR_SP_IN_PDP = 'useGraphqlForSpInPdp',
  FORCE_REST_FOR_SP_IN_PDP = 'forceRestForSpInPdp',
  ENABLE_SP_FOR_CRAWLERS_IN_PDP = 'enableSpForCrawlersInPdp',
  ENABLE_PRODUCT_PAGE_REVAMP = 'productPageRevampV2',
}
